import { FOCUS_TAB_KEY } from '../constants/tab';
import { TabType } from '../constants/tab_menu';

export const useFocusTab = () => {
  const getFocusTab = () => {
    return localStorage?.getItem(FOCUS_TAB_KEY);
  };

  const setFocusTab = (tabType: TabType) => {
    localStorage?.setItem(FOCUS_TAB_KEY, tabType.toString());
  };

  const removeFocusTab = () => {
    localStorage?.removeItem(FOCUS_TAB_KEY);
  };

  return {
    getFocusTab,
    setFocusTab,
    removeFocusTab,
  };
};
